// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__21tlF","search":"Settings_search__21Huh","filter":"Settings_filter__20GX8"};